// extracted by css-extract-rspack-plugin
export default {"wrap":"Finished__wrap--SZLIu","logo":"Finished__logo--hFRoZ","thanks":"Finished__thanks--vj48b","text":"Finished__text--dQGR5","login":"Finished__login--e8QXx"};